import { Power } from "lucide-react";
import { Button } from "@/components/ui/button";

const when = (stamp) => {
  if (!stamp) return "switched off";
  const d = new Date(stamp);
  return isNaN(d) ? "switched off" : `switched off ${d.toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" })}`;
};

/** The quiet archive below a live list: what is off, what sits behind it, and a way back. */
export const SwitchedOffList = ({ title, records, busy, onBringBack, testId }) => (
  <div className="panel bg-muted/30 p-3 sm:p-4" data-testid={testId}>
    <h2 className="text-sm font-medium text-muted-foreground">{title}</h2>
    {records.length === 0 ? (
      <p className="mt-1 text-xs text-muted-foreground" data-testid={`${testId}-empty`}>
        Nothing is switched off.
      </p>
    ) : (
      <ul className="mt-3 space-y-2">
        {records.map((r) => (
          <li
            key={r.id}
            className="flex flex-wrap items-center justify-between gap-2 rounded-md border border-border bg-background px-3 py-2"
            data-testid={`${testId}-row-${r.id}`}
          >
            <div>
              <p className="text-sm">
                {r.name} <span className="font-mono text-xs text-muted-foreground">{r.tag}</span>
              </p>
              <p className="text-xs text-muted-foreground">
                {r.poLines || 0} PO line{(r.poLines || 0) === 1 ? "" : "s"} behind it · {when(r.switchedOffAt)}
              </p>
            </div>
            <Button
              variant="outline"
              size="sm"
              onClick={() => onBringBack(r)}
              disabled={busy}
              data-testid={`${testId}-bring-back-${r.id}`}
            >
              <Power className="mr-2 h-4 w-4" />
              Bring back
            </Button>
          </li>
        ))}
      </ul>
    )}
  </div>
);

export default SwitchedOffList;
